<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_ii"></a>A<span class="smallcaps">LSO BY</span> I<span class="smallcaps">NDIA</span> E<span class="smallcaps">DGHILL</span></p>
<p class="para"> </p>
<p class="center-para"><em>Wisdom’s Daughter: A Novel of Solomon and Sheba</em></p>
<p class="center-para1a"><em>Queenmaker: A Novel of King David’s Queen</em></p>
<p class="center-para1a"><em>File M for Murder: A Cornelia Upshaw and Fancy Mystery</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?c3932dee